import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from './Sidebar';

const LG_BREAKPOINT = 1024;

function Layout({ children }) {
  const [isDesktop, setIsDesktop] = useState(() => window.innerWidth >= LG_BREAKPOINT);
  const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth >= LG_BREAKPOINT);

  // Track viewport width
  const handleResize = useCallback(() => {
    const desktop = window.innerWidth >= LG_BREAKPOINT;
    setIsDesktop(desktop);
    // Auto-close when shrinking to mobile, auto-open when growing to desktop
    if (!desktop) setSidebarOpen(false);
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return (
    <div className="min-h-screen w-full max-w-full overflow-x-hidden">
      <Sidebar
        open={sidebarOpen}
        setOpen={setSidebarOpen}
        isDesktop={isDesktop}
      />
      <main
        className={`transition-all duration-300 ease-in-out overflow-x-hidden ${
          sidebarOpen && isDesktop ? 'lg:ml-72 lg:w-[calc(100%-18rem)]' : 'ml-0 w-full'
        }`}
      >
        {children}
      </main>
    </div>
  );
}

export default Layout;
